export default __webpack_public_path__ + "static/media/deathlessacolytearcanist.391430ff.png";